import { createContext, useContext } from 'react';

/**
 * Whether the page around a region is locked, so a region can close itself without every caller
 * threading the status down by hand. Provided by `PageLayout`, which is what resolves it.
 */
const PageLockContext = createContext(false);

export const PageLockProvider = PageLockContext.Provider;

export const usePageLocked = (): boolean => useContext(PageLockContext);
